import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Assignee, UnknownAssignee } from "@webapp/assignees/models/assignee.models";
import { IItemWorkflow } from "@webapp/okrs/goals/models/goal-workflow.models";
import { AssigneeTooltipMap } from "@webapp/ui/assignee/assignee.models";
import { UiAvatarSize } from "@webapp/ui/avatar/avatar.models";
import { UiTooltipPlacement } from "@webapp/ui/tooltip/tooltip.models";

@Component({
  selector: "okr-workflow-avatar-group",
  exportAs: "okrWorkflowAvatarGroup",
  templateUrl: "okr-workflow-avatar-group.component.html",
  styleUrls: ["./okr-workflow-avatar-group.component.less"],
  host: {
    "[class.okr-ui-assignee-avatar-group-wrapper]": `true`,
    "[class.okr-ui-assignee-avatar-group-x-small]": `size === 'xs'`,
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OkrWorkflowAvatarGroupComponent implements OnInit, OnChanges {
  @Input("uiAssignees")
  public assignees?: (Assignee | UnknownAssignee)[] = [];

  @Input("uiMax")
  public max = 5;

  @Input("uiSize")
  public size?: UiAvatarSize = "xs";

  @Input("uiAssigneeTooltipPlacement")
  public assigneeTooltipPlacement?: UiTooltipPlacement;

  @Input("workflow")
  public workflow: IItemWorkflow = { reviewersNeeded: 0, reviewers: [], status: "draft", approvedAt: null };

  @Input("owner")
  public isUserOwner = false;

  @Output() public readonly openEditReviewers = new EventEmitter<void>();

  @Input("uiAssigneeTooltipMap")
  public assigneeTooltipMap?: AssigneeTooltipMap;
  public visibleAssignees: (Assignee | UnknownAssignee)[] = [];
  public hiddenAssignees: (Assignee | UnknownAssignee)[] = [];
  public fake: { reviewers: string[] };

  public ngOnInit(): void {
    this.generateFakeWorkflowReviewers();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ("assignees" in changes) {
      if (!this.assignees) {
        this.assignees = [];
      }

      const max = Math.max(0, this.max);
      this.visibleAssignees = this.assignees.slice(0, max);
      this.hiddenAssignees = this.assignees.slice(max);
    }

    if (this.workflow && changes.workflow) {
      this.generateFakeWorkflowReviewers();
    }
  }

  public getReviewerStatus(assigneeId: string): string {
    const reviewer = this.workflow.reviewers.find((reviewer) => reviewer.id === assigneeId);
    return reviewer ? reviewer.review : "";
  }

  public getReviewerStatusForLocalization(assigneeId: string, assigneeType: "hidden" | "visible"): string {
    const reviewerStatusMap = {
      approves: assigneeType === "hidden" ? "approved_okr_workflow_hidden_name" : "approved_okr_workflow",
      declines: assigneeType === "hidden" ? "declined_okr_workflow_hidden_name" : "declined_okr_workflow",
      pending: assigneeType === "hidden" ? "pending_okr_workflow_hidden_name" : "pending_okr_workflow",
    };

    const reviewer = this.workflow.reviewers.find((reviewer) => reviewer.id === assigneeId);
    return reviewer ? reviewerStatusMap[reviewer.review] : "";
  }

  public generateFakeWorkflowReviewers(): void {
    const fakeUsersArr: string[] = [];

    if (!this.workflow || !this.workflow.reviewersNeeded || !this.workflow.reviewers) {
      this.fake = {
        reviewers: fakeUsersArr,
      };
      return;
    }

    const reviewersAdded = this.workflow.reviewers.length;
    const fakeUsersCount = this.workflow.reviewersNeeded - reviewersAdded >= 0 ? this.workflow.reviewersNeeded - reviewersAdded : 0;
    for (let i = 0; i < fakeUsersCount; i++) {
      fakeUsersArr.push("");
    }

    this.fake = {
      reviewers: fakeUsersArr,
    };
  }
}
